
// Menu Drawer

document.addEventListener('DOMContentLoaded', function() {
    const drawerMenu = document.getElementById('drawerMenu');
    let bodyClass = document.body;

    function closeDrawer() {
        drawerMenu.classList.remove('visible');
        bodyClass.classList.remove('overflow-none');
        showLevel('1'); // Resets to the initial level, change this as needed
    }

    function showLevel(level) {
        // Hide all levels by adding the 'hidden' class
        document.querySelectorAll('.drawer-menu .menu-level').forEach(levelElement => {
            levelElement.classList.add('hidden-nav');
        });
        // Show the targeted level by removing the 'hidden' class
        const targetLevelElement = document.querySelector(`.drawer-menu .menu-level[data-level="${level}"]`);
        if (targetLevelElement) {
            targetLevelElement.classList.remove('hidden-nav');
        }
    }

    // Handle back navigation or page caching issues
    window.onpageshow = function(event) {
        if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
            // Page was restored from the bfcache or back navigation, ensure the drawer is closed
            closeDrawer();
        }
    };

    document.querySelectorAll('.drawer-menu .menu-item, .drawer-menu .back-btn').forEach(item => {
        item.addEventListener('click', function(event) {
            event.stopPropagation();
            const targetLevel = this.getAttribute('data-target');
            showLevel(targetLevel);
        });
    });

    // Initially open the drawer to the first level
    showLevel('1');

    document.getElementById('drawer-close').addEventListener('click', function(event) {
        event.stopPropagation();
        closeDrawer();
    });

    document.getElementById('openDrawerBtn').addEventListener('click', function(event) {
        console.log('openDrawerBtn clicked');
        event.stopPropagation();
        drawerMenu.classList.toggle('visible');
        bodyClass.classList.toggle('overflow-none');
    });
});


// Search Drawer

document.addEventListener("DOMContentLoaded", function() {
  // Get references to all elements with class "search-button"
  const searchButtons = document.querySelectorAll(".search-button");
  const searchBox = document.querySelector(".search-box");

  // Add click event listeners to all search buttons
  searchButtons.forEach(function(button) {
    button.addEventListener("click", function(event) {
      // Toggle the "visible" class to show/hide the search box
      searchBox.classList.toggle("visible-search");
      // Prevent the event from bubbling up to the document
      event.stopPropagation();
    });
  });

  // Add a click event listener to the document
  document.addEventListener("click", function(event) {
    // Check if the click target is outside the search box and all buttons
    let isOutside = true;
    searchButtons.forEach(function(button) {
      if (button.contains(event.target)) {
        isOutside = false;
      }
    });
    if (isOutside && !searchBox.contains(event.target)) {
      // If the click is outside the search box and all buttons, remove the "visible" class
      searchBox.classList.remove("visible-search");
    }
  });
});

// Sticky Menu

function checkScrollPosition() {
  const navigationHeader = document.querySelector('.navigation-header');
  const scrollPosition = window.scrollY; 
  
  if (scrollPosition > 200) {
    navigationHeader.classList.add('sticky');
  } else {
 
    navigationHeader.classList.remove('sticky');
  }
}

window.addEventListener('scroll', function() {
  requestAnimationFrame(checkScrollPosition);
});

checkScrollPosition();